import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import SequenceSingleTemplate from './SequenceSingleTemplate'
import { lang } from '../../assets/lang'

export default class SequenceSingleComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.SEQUENCE_SINGLE)

    this.data.component = SequenceSingleTemplate
    this.socket = config.sockets ? config.sockets : null
  }

  builder(node) {
    node.lingualName = lingualName.SEQUENCE_SINGLE
    this.setConnection()

    const sequenceSingleInput = new Rete.Input(CONST_SOCKET.SEQUENCE_SINGLE_INPUT, lang.sequence_single_socket_input_reply, this.socket.sequenceSingleInput, false)
    const sequenceSingleOutput = new Rete.Output(CONST_SOCKET.SEQUENCE_SINGLE_OUTPUT, lang.sequence_single_socket_output_next, this.socket.sequenceSingleOutput, false)

    return node
      .addInput(sequenceSingleInput)
      .addOutput(sequenceSingleOutput)
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {

  }

  setConnection() {
    this.socket.sequenceSingleInput.combineWith(this.socket.sequenceOutput)

    this.socket.sequenceSingleOutput.combineWith(this.socket.newPostbackInput)
  }
}